(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.cc-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-cc-target'), 10) || 0;
    var prefix = el.getAttribute('data-cc-prefix') || '';
    var suffix = el.getAttribute('data-cc-suffix') || '';
    var duration = parseInt(el.getAttribute('data-cc-duration'), 10) || 2000;
    var start = null;

    function format(n) {
      return prefix + n.toLocaleString('es-AR') + suffix;
    }

    function step(ts) {
      if (start === null) start = ts;
      var elapsed = ts - start;
      var progress = Math.min(elapsed / duration, 1);
      // easeOutCubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(target * eased);
      el.textContent = format(current);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = format(target);
      }
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-cc-counter]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { animateCounter(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initUserIconLogin() {
    // Forzar que el icono de usuario del header vaya a /account/login
    document.querySelectorAll('.header__icon--account, a[href="/account"], a[href$="/account"]').forEach(function (el) {
      var href = el.getAttribute('href') || '';
      if (href === '/account' || href.endsWith('/account')) {
        el.setAttribute('href', '/account/login');
      }
    });
  }

  function initCountdown() {
    var el = document.querySelector('[data-cc-countdown]');
    if (!el) return;

    var hoursSpan = el.querySelector('[data-cc-h]');
    var minsSpan = el.querySelector('[data-cc-m]');
    var secsSpan = el.querySelector('[data-cc-s]');
    if (!hoursSpan || !minsSpan || !secsSpan) return;

    var storageKey = 'ccOfferEnd';
    var duration = parseInt(el.getAttribute('data-cc-duration'), 10) || 24; // horas

    function getEnd() {
      var stored = null;
      try { stored = localStorage.getItem(storageKey); } catch (e) {}
      var parsed = stored ? parseInt(stored, 10) : 0;
      var now = Date.now();
      if (!parsed || parsed <= now) {
        parsed = now + duration * 60 * 60 * 1000;
        try { localStorage.setItem(storageKey, String(parsed)); } catch (e) {}
      }
      return parsed;
    }

    var endTime = getEnd();

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = Math.max(0, endTime - Date.now());
      if (diff === 0) {
        try { localStorage.removeItem(storageKey); } catch (e) {}
        endTime = getEnd();
        diff = endTime - Date.now();
      }
      var totalSec = Math.floor(diff / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      hoursSpan.textContent = pad(h);
      minsSpan.textContent = pad(m);
      secsSpan.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  function init() {
    initReveal();
    initCounters();
    initUserIconLogin();
    initCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
